import { YearPicker, useLandManagement, useLandReportView } from '@cibo/landmanager'
import { ActionBar } from '@cibo/ui'
import { Button, Stack } from '@mui/material'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface LandReportActionBarProps {
  resourceId?: string
}

export const LandReportActionBar = ({ resourceId }: LandReportActionBarProps) => {
  const { t } = useTranslation('impact/LandReportActionBar')
  const { field, focusYear, reportYears, setFocusYear } = useLandReportView({ resourceId })
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const { openFieldMetaDialog, confirmDeleteField } = useLandManagement()

  const handleDeleteField = () => {
    if (resourceId) {
      confirmDeleteField(resourceId).then(() => {
        navigate(LAND_MANAGER_ROUTES.ROOT)
      })
    }
  }

  if (!field) {
    return null
  }

  return (
    <ActionBar>
      <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="space-between">
        <Stack flex={1} justifyContent="center" maxWidth={350}>
          <YearPicker reportYears={reportYears} focusYear={focusYear} setFocusYear={setFocusYear} />
        </Stack>

        <Stack alignItems="flex-end" justifyContent="center" flex={3}>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              color="error"
              onClick={handleDeleteField}
              disabled={field.isLoading || field.isRefetching || !field.data?.can(['delete'])}
            >
              {t('delete')}
            </Button>
            <Button
              data-testid="edit-field-button"
              variant="contained"
              disabled={field.isLoading || field.isRefetching || !field.data?.can(['edit_meta'])}
              onClick={() =>
                openFieldMetaDialog({
                  resourceId: field.data?.resourceId,
                  onSuccess: (values: any) => {
                    enqueueSnackbar(t('updateSuccess', { name: values.name }), {
                      variant: 'success',
                    })
                  },
                })
              }
            >
              {t('edit')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </ActionBar>
  )
}
